import image01 from '../images/content-master/01.jpg';
import imageWebp01 from '../images/content-master/01.webp';

import image11 from '../images/content-master/11.jpg';
import imageWebp11 from '../images/content-master/11.webp';

import nuevo1 from '../images/content-master/Nuevo 1.jpg';
import nuevo2 from '../images/content-master/Nuevo 2.jpg';
import nuevo4 from '../images/content-master/Nuevo 4.jpg';
import nuevo5 from '../images/content-master/Nuevo 5.png';
import nuevo6 from '../images/content-master/Nuevo 6.jpg';
import Monky from '../images/content-master/Monky.png';
import EjercicioRostro from '../images/content-master/EjercicioRostro.jpeg';
import Fox from '../images/content-master/Fox.jpg';
import NiñoWarrior from '../images/content-master/NiñoWarrior.png';
import Environment from '../images/content-master/Environment.jpeg';
import Ragnar from '../images/content-master/Ragnar.jpeg';
import Nivara from '../images/content-master//Nivara.jpg';
import koala from '../images/content-master/Koala.jpg';
import zorro from '../images/content-master/Zorro.jpg';
import jin from '../images/content-master/Jin.jpg';

const contentMaster = [
	{
		id: '01',
		title: 'Zephyr para videojuegos',
		image: nuevo6,
		imageWebp: nuevo6,
		description: 'Crearemos este fantástico personaje estilizado para videojuegos.',
		video: '',
		sinvideo: true,
	},
	{
		id: '02',
		title: 'Nivara',
		image: Nivara,
		imageWebp: Nivara,
		description: 'Domina la escultura facial con Blender y dale personalidad a tus personajes.',
		video: '',
		sinvideo: true,
	},
	// {
	// 	id: '03',
	// 	title: 'Red Girl para Animación',
	// 	image: nuevo1,
	// 	imageWebp: nuevo1,
	// 	description:
	// 		'Crea sorprendentes personajes para videojuegos desde cero con Blender y Substance Painter.',
	// 	video: 'https://youtu.be/OZ0_q-g2SI4',
	// },
	// {
	// 	id: '04',
	// 	title: 'Escultura en Blender',
	// 	image: nuevo2,
	// 	imageWebp: nuevo2,
	// 	description: 'Aprende desde cero y crea sorprendentes modelos anime con Blender.',
	// 	video: 'https://youtu.be/OZ0_q-g2SI4',
	// 	// sinvideo: true,
	// },
	{
		id: '03',
		title: 'Personaje para Animación',
		image: image11,
		imageWebp: imageWebp11,
		description: 'Crea sorprendentes personajes para videojuegos y llévalo a unreal engine 5.',
		video: 'https://www.youtube.com/watch?v=CXXX3NdTV68',
	},
	{
		id: '04',
		title: 'Personajes para Animación',
		image: image01,
		imageWebp: imageWebp01,
		description:
			'Aprende y crea personajes para animación desde cero con BLENDER Y SUBSTANCE PAINTER.',
	},
	// {
	// 	id: '07',
	// 	title: 'Niño warrior',
	// 	image: NiñoWarrior,
	// 	imageWebp: NiñoWarrior,
	// 	description:
	// 		'Sigue tu curva de aprendizaje creando este fantástico personaje aplicando técnicas de escultura en Blender.',
	// },
	{
		id: '05',
		title: 'Fox',
		image: Fox,
		imageWebp: Fox,
		description: 'Vive una nueva experiencia de creación Rig y animación básica.',
		video: 'https://www.youtube.com/watch?v=QzU31Rxvp18',
	},
	{
		id: '06',
		title: 'Anatomía Facial Takoda',
		image: EjercicioRostro,
		imageWebp: EjercicioRostro,
		description:
			'Trabajaremos con este grandioso personaje con el objetivo de lograr encontrar tu flujo de trabajo en la creación de rostro.',
	},
	// {
	// 	id: '10',
	// 	title: 'Monky',
	// 	image: Monky,
	// 	imageWebp: Monky,
	// 	description:
	// 		'Sigue tu proceso de aprendizaje con este fantástico modelo donde el objetivo es encontrar tu flujo de trabajo.',
	// },
	{
		id: '07',
		title: 'Creando a JIN',
		image: jin,
		imageWebp: jin,
		description: 'Sigue tu proceso de aprendizaje y crea este fantástico panda desde cero',
	},
	{
		id: '08',
		title: 'Koala',
		image: koala,
		imageWebp: koala,
		description:
			'Da tus primeros pasos en Blender y adáptate a la interfaz con este entrenamiento especializado.',
	},
	{
		id: '09',
		title: 'Zorro',
		image: zorro,
		imageWebp: zorro,
		description:
			'No importa si estas en cero, nuestro metodo de estudio te ayudara a organizar tu curva de aprendizaje.',
	},
];

export const contentMaster2 = [
	{
		id: '01',
		title: 'Zephyr para videojuegos',
		image: nuevo6,
		imageWebp: nuevo6,
		description: 'Crearemos este fantástico personaje estilizado para videojuegos.',
		video: '',
		sinvideo: true,
	},
	{
		id: '02',
		title: 'Nivara',
		image: Nivara,
		imageWebp: Nivara,
		description: 'Domina la escultura facial con Blender y dale personalidad a tus personajes.',
		video: '',
		sinvideo: true,
	},
	{
		id: '03',
		title: 'Environment',
		image: Environment,
		imageWebp: Environment,
		description: 'Crea sorprendentes escenarios para videojuegos con Blender y Substance Painter.',
		video: '',
		sinvideo: true,
	},
	{
		id: '04',
		title: 'Ragnar',
		image: Ragnar,
		imageWebp: Ragnar,
		description:
			'Refuerza tu flujo de trabajo creando este fantástico personaje en Blender y Substance Painter.',
		video: '',
		sinvideo: true,
	},
	// {
	// 	id: '05',
	// 	title: 'Rostros para animación',
	// 	image: nuevo5,
	// 	imageWebp: nuevo5,
	// 	description:
	// 		'Sé un especialista en la creación de rostros para videojuegos con BLENDER Y SUBSTANCE PAINTER.',
	// 	video: 'https://www.youtube.com/watch?v=RWSGWM5xSjc',
	// },
	// {
	// 	id: '06',
	// 	title: 'Red Girl para Animación',
	// 	image: nuevo1,
	// 	imageWebp: nuevo1,
	// 	description:
	// 		'Crea sorprendentes personajes para videojuegos desde cero con Blender y Substance Painter.',
	// 	video: 'https://youtu.be/OZ0_q-g2SI4',
	// },
	// {
	// 	id: '07',
	// 	title: 'Escultura en Blender',
	// 	image: nuevo2,
	// 	imageWebp: nuevo2,
	// 	description: 'Aprende desde cero y crea sorprendentes modelos anime con Blender.',
	// 	video: 'https://youtu.be/OZ0_q-g2SI4',
	// 	// sinvideo: true,
	// },
	{
		id: '05',
		title: 'Personaje para Animación',
		image: image11,
		imageWebp: imageWebp11,
		description: 'Crea sorprendentes personajes para videojuegos y llévalo a unreal engine 5.',
		video: 'https://www.youtube.com/watch?v=CXXX3NdTV68',
	},
	{
		id: '06',
		title: 'Personajes Estilizados',
		image: nuevo4,
		imageWebp: nuevo4,
		description:
			'Consolida tus conocimientos en Blender y logra adquirir excelentes bases en el proceso de creación de personajes.',
		video: 'https://youtu.be/OZ0_q-g2SI4',
		// sinvideo: true,
	},
	{
		id: '07',
		title: 'Personajes para Animación',
		image: image01,
		imageWebp: imageWebp01,
		description:
			'Aprende y crea personajes para animación desde cero con BLENDER Y SUBSTANCE PAINTER.',
	},
	// {
	// 	id: '11',
	// 	title: 'Niño warrior',
	// 	image: NiñoWarrior,
	// 	imageWebp: NiñoWarrior,
	// 	description:
	// 		'Sigue tu curva de aprendizaje creando este fantástico personaje aplicando técnicas de escultura en Blender.',
	// },
	{
		id: '08',
		title: 'Fox',
		image: Fox,
		imageWebp: Fox,
		description: 'Vive una nueva experiencia de creación Rig y animación básica.',
		video: 'https://www.youtube.com/watch?v=QzU31Rxvp18',
	},
	{
		id: '09',
		title: 'Ejercicio Rostro',
		image: EjercicioRostro,
		imageWebp: EjercicioRostro,
		description:
			'Trabajaremos con este grandioso personaje con el objetivo de lograr encontrar tu flujo de trabajo en la creación de rostro.',
	},
	// {
	// 	id: '14',
	// 	title: 'Monky',
	// 	image: Monky,
	// 	imageWebp: Monky,
	// 	description:
	// 		'Sigue tu proceso de aprendizaje con este fantástico modelo donde el objetivo es encontrar tu flujo de trabajo.',
	// },
	{
		id: '10',
		title: 'Creando a JIN',
		image: jin,
		imageWebp: jin,
		description: 'Sigue tu proceso de aprendizaje y crea este fantástico panda desde cero',
	},
	{
		id: '11',
		title: 'Koala',
		image: koala,
		imageWebp: koala,
		description:
			'Da tus primeros pasos en Blender y adáptate a la interfaz con este entrenamiento especializado.',
	},
	{
		id: '12',
		title: 'Zorro',
		image: zorro,
		imageWebp: zorro,
		description:
			'No importa si estas en cero, nuestro metodo de estudio te ayudara a organizar tu curva de aprendizaje.',
	},
];

export const contentMaster3 = [
	{
		id: '01',
		title: 'Zephyr para videojuegos',
		image: nuevo6,
		imageWebp: nuevo6,
		description: 'Crearemos este fantástico personaje estilizado para videojuegos.',
		video: '',
		sinvideo: true,
	},
	{
		id: '02',
		title: 'Creando a JIN',
		image: jin,
		imageWebp: jin,
		description: 'Sigue tu proceso de aprendizaje y crea este fantástico panda desde cero',
		video: '',
		sinvideo: true,
	},
	{
		id: '03',
		title: 'Koala',
		image: koala,
		imageWebp: koala,
		description:
			'Da tus primeros pasos en Blender y adáptate a la interfaz con este entrenamiento especializado.',
		video: '',
		sinvideo: true,
	},
	{
		id: '04',
		title: 'Zorro',
		image: zorro,
		imageWebp: zorro,
		description:
			'No importa si estas en cero, nuestro metodo de estudio te ayudara a organizar tu curva de aprendizaje.',
		video: '',
		sinvideo: true,
	},
];

export default contentMaster;
